import {connect} from 'react-redux';
import selectRouteOption from 'Data/actionCreators/kiosk/selectRouteOption';
import RouteOptions from 'Components/common/RouteOptions/RouteOptions';
import {isThereExternalLocations} from 'Utils/routingUtils';

const mapStateToProps = (state, props) => ({
    journeyExist: !!(
        state.pageState.explorerMap.journey.stops[0]?.id &&
        state.pageState.explorerMap.journey.stops[1]?.id
    ),
    destination: state.pageState.explorerMap.journey.stops[1],
    internalJourney: !isThereExternalLocations(state.pageState.explorerMap.journey.stops),
    selectedRouteOption: state.pageState.explorerMap.selectedRouteOption,
    travelTimeMins: Math.round(state.pageState.explorerMap.journey.travelTimeMins),
    distanceMeters: Math.round(state.pageState.explorerMap.journey.distanceMeters),
    displayNightSafe:
        state.pageState?.layout?.config?.settings?.mapConfig?.nightSafeRoute?.enabled ||
        props.isMapEditorPreview,
    unitOfMeasure: state.pageState?.layout?.config?.settings?.units,
    primaryColors: state.pageState.layout?.config?.settings?.brandingConfig?.primary?.colors
        ? state.pageState.layout?.config?.settings?.brandingConfig?.primary?.colors
        : {text: '#FFFFFF', background: '#1492FF'},
});

export default connect(
    mapStateToProps,
    {selectRouteOption}
)(RouteOptions);
